export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 6_01.afc87c9a.jpg";